// extracted by mini-css-extract-plugin
module.exports = {"lineSetting":"index-module--line-setting--BfsAn","lineColor":"index-module--line-color--2yR-y","inline":"index-module--inline--2SftJ"};